import {
  PERIODICITY_FILE_LABELS,
  REPORTING_BASE_FILE_NAMES,
  REPORTING_INITIAL_CONFIG,
} from '~/constants/reportingModal';

export type LegacyReportingFilenameContext = {
  selectedReporting: number;
  absencesubscribedcheckvalue: number;
  billingvolantcheckvalue: number;
  billingSubscribedValue: number;
  extensionsubscriptionvalue: number;
  cashDepositValue: number;
  cashDepositCompleteValue: number;
  unpaidmerchantvalue: number;
  eventvalue: number;
  recapMerchantValue: number;
  subscriptionInValue: number;
  subscriptionOutValue: number;
  cityRegroupValue: number;
  cityRegroup2Value: number;
  selectedCity: number | null;
  selectedPlacer: string;
  selectedPeriodicity: string;
  startdateformatfr: string;
  enddateformatfr: string;
  incomeWithPlacerValue: number;
  chartsValue: number;
  cityName: Record<number, string>;
  placerName: Record<number, string>;
};

export const extractFilenameFromContentDisposition = (header: string | null): string | null => {
  if (!header) {
    return null;
  }

  const utf8Filename = header.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (utf8Filename) {
    return decodeURIComponent(utf8Filename).replace(/^"|"$/g, '');
  }

  const fallbackFilename = header.match(/filename=([^;]+)/i)?.[1];
  if (fallbackFilename) {
    return fallbackFilename.trim().replace(/^"|"$/g, '');
  }

  return null;
};

export const buildLegacyReportingFilename = (context: LegacyReportingFilenameContext): string => {
  const config = REPORTING_INITIAL_CONFIG[context.selectedReporting] || {};
  const reportingType = context.selectedReporting;

  const PALabel = reportingType === 1 && context.absencesubscribedcheckvalue === 1 ? '_PA' : '';
  const FVLabel = reportingType === 1 && context.billingvolantcheckvalue === 1 ? '_FV' : '';
  const FALabel = reportingType === 1 && context.billingSubscribedValue === 1 ? '_FA' : '';
  const EALabel = reportingType === 1 && context.extensionsubscriptionvalue === 1 ? '_EA' : '';
  const ENCLabel = reportingType === 1 && context.cashDepositValue === 1 ? '_ENC' : '';
  const ENCDLabel = reportingType === 1 && context.cashDepositCompleteValue === 1 ? 'D' : '';
  const IMPLabel = reportingType === 1 && context.unpaidmerchantvalue === 1 ? '_IMP' : '';
  const SIGLabel = reportingType === 1 && context.eventvalue === 1 ? '_SIG' : '';
  const RCLabel = reportingType === 1 && context.recapMerchantValue === 1 ? '_RC' : '';

  const inLabel = reportingType === 2 && context.subscriptionInValue === 1 ? '_Entrees' : '';
  const outLabel = reportingType === 2 && context.subscriptionOutValue === 1 ? '_Sorties' : '';

  const subLabel = reportingType === 3 && context.selectedCity === -2 && context.cityRegroupValue === 1
    ? '_Sans_Regroupement'
    : '';
  const cityRegroupLabel = reportingType === 3 && (
    (context.selectedCity === -2 && context.cityRegroup2Value === 1)
    || (context.selectedCity !== null && context.selectedCity > 0 && context.cityRegroupValue === 1)
  )
    ? '_Regroupe_Par_Ville'
    : '';
  const marketRegroupLabel = reportingType === 3 && (
    (context.selectedCity === -2 && context.cityRegroupValue === 0 && context.cityRegroup2Value === 0)
    || (context.selectedCity !== null && context.selectedCity > 0 && context.cityRegroupValue === 0)
  )
    ? '_Regroupe_Par_Marche'
    : '';

  const cityLabel = context.selectedCity
    && (config.allCitiesList === true || config.cityList === true)
    ? `_${context.cityName[context.selectedCity]}`
    : '';

  const placerId = Number(context.selectedPlacer);
  const placerLabel = context.selectedPlacer.length > 0 && config.placerList === true
    ? `_${context.placerName[placerId]}`
    : '';

  const periodicityId = Number(context.selectedPeriodicity);
  const periodicityLabel = context.selectedPeriodicity.length > 0 && config.periodicityList === true
    ? `_${PERIODICITY_FILE_LABELS[periodicityId]}`
    : '';

  const startDateLabel = context.startdateformatfr.length > 0 && config.fromList === true
    ? `_${context.startdateformatfr}`
    : '';
  const endDateLabel = context.enddateformatfr.length > 0 && config.toList === true
    ? `_${context.enddateformatfr}`
    : '';
  const incomeWithPlacerLabel = context.incomeWithPlacerValue === 1 && config.incomewithplacercheck === true
    ? '_Avec_Recettes_Placier'
    : '';
  const chartsLabel = context.chartsValue === 1 && config.chartscheck === true
    ? '_Sans_Graphique'
    : '';

  return `${REPORTING_BASE_FILE_NAMES[reportingType] ?? 'Reporting'}`
    + PALabel + FVLabel + FALabel + EALabel + ENCLabel + ENCDLabel + IMPLabel + SIGLabel + RCLabel
    + inLabel + outLabel
    + subLabel + cityRegroupLabel + marketRegroupLabel
    + cityLabel
    + placerLabel + periodicityLabel
    + startDateLabel + endDateLabel
    + incomeWithPlacerLabel + chartsLabel;
};
